module.exports = __webpack_public_path__ + "static/media/google-drive-social-media-svgrepo-com.6b3b9501.svg";